module.exports = __webpack_public_path__ + "img/archive.564608c6.svg";